import { TAG_CATEGORY } from '../constants';

export default {
  [TAG_CATEGORY.sustainableFood]: [
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'food_matters',
      hasSecondaryInfo: true,
    },
    {
      type: 'statement',
    },
  ],
  [TAG_CATEGORY.plastic]: [
    {
      type: 'stat',
      imagePath: 'images/challenge/knowledgeBackground/plasticStat.png',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'disappearing_plastic',
      hasSecondaryInfo: true,
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'microplastics',
      hasSecondaryInfo: true,
    },
    {
      type: 'statement',
      contentTag: 'avoid_plastic',
      hasSecondaryInfo: true,
    },
  ],
  [TAG_CATEGORY.foodWaste]: [
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'food_matters',
      hasSecondaryInfo: true,
    },
    {
      type: 'statement',
    },
  ],
  [TAG_CATEGORY.consumption]: [
    {
      type: 'stat',
      imagePath:
        'images/challenge/knowledgeBackground/goodsAndServicesStat.png',
    },
    {
      type: 'quiz',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'not_buying',
      backgroundColor: '#FCD7DF',
      hasSecondaryInfo: true,
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'voting',
      hasSecondaryInfo: true,
    },
    {
      type: 'statement',
    },
  ],
  [TAG_CATEGORY.energy]: [
    {
      type: 'stat',
      imagePath: 'images/challenge/knowledgeBackground/energyStat.png',
    },
    {
      type: 'quiz',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'producing_electricity',
      backgroundColor: '#C6EEF7',
      hasSecondaryInfo: true,
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'renewable_energy',
    },
    {
      type: 'statement',
      contentTag: 'save_energy',
      hasSecondaryInfo: true,
    },
  ],
  [TAG_CATEGORY.transport]: [
    {
      type: 'stat',
      imagePath: 'images/challenge/knowledgeBackground/transportStat.png',
    },
    {
      type: 'quiz',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'using_transport',
      hasSecondaryInfo: true,
    },
    {
      type: 'statement',
      contentTag: 'politicians',
      hasSecondaryInfo: true,
    },
  ],
  [TAG_CATEGORY.food]: [
    {
      type: 'stat',
      imagePath: 'images/challenge/knowledgeBackground/foodStat.png',
    },
    {
      type: 'quiz',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'food_production',
      backgroundColor: '#FCEAC6',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'eating_habits',
      hasSecondaryInfo: true,
    },
    {
      type: 'statement',
      contentTag: 'eating_habits',
      hasSecondaryInfo: true,
    },
  ],
  [TAG_CATEGORY.handprint]: [
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'positive_impact',
      hasSecondaryInfo: true,
    },
    {
      type: 'statement',
    },
  ],
  [TAG_CATEGORY.overuse]: [
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'so_much_plastic',
      hasSecondaryInfo: true,
    },
    {
      type: 'statement',
    },
  ],
  [TAG_CATEGORY.plasticOnTheGo]: [
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'ocean_plastic',
      hasSecondaryInfo: true,
    },
    {
      type: 'statement',
    },
  ],
  [TAG_CATEGORY.microplastics]: [
    {
      type: 'stat',
      imagePath: 'images/challenge/knowledgeBackground/plasticStat.png',
    },
    {
      type: 'quiz',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'disappearing_plastic',
      backgroundColor: '#CDF2F7',
      hasSecondaryInfo: true,
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.did_you_know',
      contentTag: 'microplastics',
      hasSecondaryInfo: true,
    },
    {
      type: 'statement',
      contentTag: 'avoid_plastic',
      hasSecondaryInfo: true,
    },
  ],
  [TAG_CATEGORY.sdg3]: [
    {
      type: 'categoryImage',
    },
    {
      type: 'didYouKnow',
      backgroundColor: 'rgba(39, 155, 72, 0.1)',
      overlineText: 'challenge.tags.why_relevant',
      contentTag: 'urgent_call',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.main_goal',
      contentTag: 'healthy_lives',
      hrefText: 'challenge.tags.learn_more_un',
      href: 'https://sdgs.un.org/goals/goal3',
    },
    {
      type: 'image',
      imagePath: 'images/challenge/knowledgeBackground/sdgs.png',
    },
  ],
  [TAG_CATEGORY.sdg6]: [
    {
      type: 'categoryImage',
    },
    {
      type: 'didYouKnow',
      backgroundColor: 'rgba(39, 155, 72, 0.1)',
      overlineText: 'challenge.tags.why_relevant',
      contentTag: 'urgent_call',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.main_goal',
      contentTag: 'water_access',
      hrefText: 'challenge.tags.learn_more_un',
      href: 'https://sdgs.un.org/goals/goal6',
    },
    {
      type: 'image',
      imagePath: 'images/challenge/knowledgeBackground/sdgs.png',
    },
  ],
  [TAG_CATEGORY.sdg8]: [
    {
      type: 'categoryImage',
    },
    {
      type: 'didYouKnow',
      backgroundColor: 'rgba(39, 155, 72, 0.1)',
      overlineText: 'challenge.tags.why_relevant',
      contentTag: 'urgent_call',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.main_goal',
      contentTag: 'sustainable_growth',
      hrefText: 'challenge.tags.learn_more_un',
      href: 'https://sdgs.un.org/goals/goal8',
    },
    {
      type: 'image',
      imagePath: 'images/challenge/knowledgeBackground/sdgs.png',
    },
  ],
  [TAG_CATEGORY.sdg9]: [
    {
      type: 'categoryImage',
    },
    {
      type: 'didYouKnow',
      backgroundColor: 'rgba(39, 155, 72, 0.1)',
      overlineText: 'challenge.tags.why_relevant',
      contentTag: 'urgent_call',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.main_goal',
      contentTag: 'resilient_infrastructure',
      hrefText: 'challenge.tags.learn_more_un',
      href: 'https://sdgs.un.org/goals/goal9',
    },
    {
      type: 'image',
      imagePath: 'images/challenge/knowledgeBackground/sdgs.png',
    },
  ],
  [TAG_CATEGORY.sdg10]: [
    {
      type: 'categoryImage',
    },
    {
      type: 'didYouKnow',
      backgroundColor: 'rgba(39, 155, 72, 0.1)',
      overlineText: 'challenge.tags.why_relevant',
      contentTag: 'urgent_call',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.main_goal',
      contentTag: 'reduce_inequality',
      hrefText: 'challenge.tags.learn_more_un',
      href: 'https://sdgs.un.org/goals/goal10',
    },
    {
      type: 'image',
      imagePath: 'images/challenge/knowledgeBackground/sdgs.png',
    },
  ],
  [TAG_CATEGORY.sdg11]: [
    {
      type: 'categoryImage',
    },
    {
      type: 'didYouKnow',
      backgroundColor: 'rgba(39, 155, 72, 0.1)',
      overlineText: 'challenge.tags.why_relevant',
      contentTag: 'urgent_call',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.main_goal',
      contentTag: 'inclusive_cities',
      hrefText: 'challenge.tags.learn_more_un',
      href: 'https://sdgs.un.org/goals/goal11',
    },
    {
      type: 'image',
      imagePath: 'images/challenge/knowledgeBackground/sdgs.png',
    },
  ],
  [TAG_CATEGORY.sdg12]: [
    {
      type: 'categoryImage',
    },
    {
      type: 'didYouKnow',
      backgroundColor: 'rgba(39, 155, 72, 0.1)',
      overlineText: 'challenge.tags.why_relevant',
      contentTag: 'urgent_call',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.main_goal',
      contentTag: 'sustainable_consumption',
      hrefText: 'challenge.tags.learn_more_un',
      href: 'https://sdgs.un.org/goals/goal12',
    },
    {
      type: 'image',
      imagePath: 'images/challenge/knowledgeBackground/sdgs.png',
    },
  ],
  [TAG_CATEGORY.sdg13]: [
    {
      type: 'categoryImage',
    },
    {
      type: 'didYouKnow',
      backgroundColor: 'rgba(39, 155, 72, 0.1)',
      overlineText: 'challenge.tags.why_relevant',
      contentTag: 'urgent_call',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.main_goal',
      contentTag: 'urgent_action',
      hrefText: 'challenge.tags.learn_more_un',
      href: 'https://sdgs.un.org/goals/goal13',
    },
    {
      type: 'image',
      imagePath: 'images/challenge/knowledgeBackground/sdgs.png',
    },
  ],
  [TAG_CATEGORY.sdg14]: [
    {
      type: 'categoryImage',
    },
    {
      type: 'didYouKnow',
      backgroundColor: 'rgba(39, 155, 72, 0.1)',
      overlineText: 'challenge.tags.why_relevant',
      contentTag: 'urgent_call',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.main_goal',
      contentTag: 'conserve_oceans',
      hrefText: 'challenge.tags.learn_more_un',
      href: 'https://sdgs.un.org/goals/goal14',
    },
    {
      type: 'image',
      imagePath: 'images/challenge/knowledgeBackground/sdgs.png',
    },
  ],
  [TAG_CATEGORY.sdg15]: [
    {
      type: 'categoryImage',
    },
    {
      type: 'didYouKnow',
      backgroundColor: 'rgba(39, 155, 72, 0.1)',
      overlineText: 'challenge.tags.why_relevant',
      contentTag: 'urgent_call',
    },
    {
      type: 'didYouKnow',
      overlineText: 'challenge.tags.main_goal',
      contentTag: 'sustainable_management',
      hrefText: 'challenge.tags.learn_more_un',
      href: 'https://sdgs.un.org/goals/goal15',
    },
    {
      type: 'image',
      imagePath: 'images/challenge/knowledgeBackground/sdgs.png',
    },
  ],
};
